<template>
    <v-card :loading="loading" mx-4>
        <v-skeleton-loader
            v-if="loading"
            type="card"
        ></v-skeleton-loader>
        <v-tabs
            v-else
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii personal
            </v-tab>
            <v-tab key="user">
                Date de autentificare
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">

            <v-tab-item key="general">
                <v-card class="px-4 py-4" flat>
                    <v-row>
                        <v-col cols="9">
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.family_name"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.family_name')"
                                        :class="{ 'error--text': hasErrors('data.family_name') }"
                                        class="primary--text"
                                        label="Nume"
                                        data-vv-as="Nume"
                                        data-vv-name="data.family_name"
                                        counter="255"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.name"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.name')"
                                        :class="{ 'error--text': hasErrors('data.name') }"
                                        class="primary--text"
                                        label="Prenume"
                                        data-vv-as="Prenume"
                                        data-vv-name="data.name"
                                        counter="255"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-select
                                        :items="genders"
                                        item-text="name"
                                        item-value="value"
                                        v-model="form.data.gender"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.gender')"
                                        :class="{ 'error--text': hasErrors('data.gender') }"
                                        class="primary--text"
                                        label="Sex"
                                        data-vv-as="Sex"
                                        data-vv-name="data.gender"
                                    />
                                </v-col>

                                <v-col cols="1">
                                    <v-text-field
                                        v-model="form.data.id_serial"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.id_serial')"
                                        :class="{ 'error--text': hasErrors('data.id_serial') }"
                                        class="primary--text"
                                        label="Serie CI"
                                        data-vv-as="Serie CI"
                                        data-vv-name="data.id_serial"
                                        counter="2"
                                    />
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field-integer
                                        v-model="form.data.id_no"
                                        label="Numar CI"
                                        data-vv-as="Numar CI"
                                        v-bind:properties="{
                                            errorMessages: errorMessages('data.id_no'),
                                            class: {'primary--text': true, 'error--text': hasErrors('data.id_no') },
                                            vValidate: 'required',
                                            dataVvName: 'data.id_no',
                                            counter: 6
                                        }"
                                        v-bind:options="{
                                            inputMask: '######',
                                            outputMask: '######',
                                            empty: null,
                                            applyAfter: false,
                                      }"
                                    />
                                </v-col>
                                <v-col cols="5">
                                    <v-text-field-integer
                                        v-model="form.data.pin"
                                        label="CNP"
                                        data-vv-as="CNP"
                                        v-bind:properties="{
                                            errorMessages: errorMessages('data.pin'),
                                            class: {'primary--text': true, 'error--text': hasErrors('data.pin') },
                                            vValidate: 'required',
                                            dataVvName: 'data.pin',
                                            counter: 13
                                        }"
                                        v-bind:options="{
                                            inputMask: '#############',
                                            outputMask: '#############',
                                            empty: null,
                                            applyAfter: false,
                                      }"
                                    />
                                </v-col>
                                <v-col cols="2">
                                    <v-select
                                        v-model="form.data.department"
                                        :items="departments"
                                        item-text="name"
                                        item-value="value"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.department')"
                                        :class="{ 'error--text': hasErrors('data.department') }"
                                        class="primary--text"
                                        label="Departament"
                                        data-vv-as="Departament"
                                        data-vv-name="data.department"
                                    />
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                        v-model="form.data.function"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.function')"
                                        :class="{ 'error--text': hasErrors('data.function') }"
                                        class="primary--text"
                                        label="Functie"
                                        data-vv-as="Functie"
                                        data-vv-name="data.function"
                                    />
                                </v-col>

                                <v-col cols="3">
                                    <v-select
                                        :items="Static.counties"
                                        item-text="name"
                                        item-value="id"
                                        v-model="form.data.county_id"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.county_id')"
                                        :class="{ 'error--text': hasErrors('data.county_id') }"
                                        class="primary--text"
                                        label="Judet"
                                        data-vv-as="Judet"
                                        data-vv-name="data.county_id"
                                    />
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field
                                        v-model="form.data.city"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.city')"
                                        :class="{ 'error--text': hasErrors('data.city') }"
                                        class="primary--text"
                                        label="Localitate"
                                        data-vv-as="Localitate"
                                        data-vv-name="data.city"
                                        counter="255"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.address"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.address')"
                                        :class="{ 'error--text': hasErrors('data.address') }"
                                        class="primary--text"
                                        label="Strada"
                                        data-vv-as="Strada"
                                        data-vv-name="data.address"
                                        counter="255"
                                    />
                                </v-col>
                                <v-col cols="1">
                                    <v-text-field
                                        v-model="form.data.address_no"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.address_no')"
                                        :class="{ 'error--text': hasErrors('data.address_no') }"
                                        class="primary--text"
                                        label="Nr"
                                        data-vv-as="Nr"
                                        data-vv-name="data.address_no"
                                    />
                                </v-col>
                                <v-col cols="1">
                                    <v-text-field
                                        v-model="form.data.address_ap"
                                        v-validate="''"
                                        :error-messages="errorMessages('data.address_ap')"
                                        :class="{ 'error--text': hasErrors('data.address_ap') }"
                                        class="primary--text"
                                        label="Ap"
                                        data-vv-as="Ap"
                                        data-vv-name="data.address_ap"
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field
                                        v-model="form.data.phone"
                                        v-validate="'required'"
                                        :error-messages="errorMessages('data.phone')"
                                        :class="{ 'error--text': hasErrors('data.phone') }"
                                        class="primary--text"
                                        label="Telefon"
                                        data-vv-as="Telefon"
                                        data-vv-name="data.phone"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="3">
                            <v-img v-if="imagePath" :src="imagePath"></v-img>
                            <v-file-input
                                class="primary--text mt-3"
                                label="Imagine"
                                @change="changePreview"
                                v-model="image"
                            >
                            </v-file-input>
                        </v-col>
                    </v-row>

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item key="user">
                <v-card class="px-4 py-4" flat>
                    <v-text-field
                        v-model="form.name"
                        v-validate="'required'"
                        :error-messages="errorMessages('name')"
                        :class="{ 'error--text': hasErrors('name') }"
                        class="primary--text"
                        label="Nume"
                        data-vv-name="name"
                        counter="255"
                    />
                    <v-text-field-simplemask
                        v-model="form.username"
                        label="Utilizator"
                        v-bind:properties="{
                            errorMessages: errorMessages('username'),
                            class: {'primary--text': true, 'error--text': hasErrors('username') },
                            vValidate: 'required',
                            dataVvName: 'username',
                            counter: 10
                        }"
                        v-bind:options="{
                            inputMask: '####-###-###',
                            outputMask: '##########',
                            empty: null,
                            applyAfter: false,
                        }"
                    />
                    <v-text-field
                        v-model="form.email"
                        v-validate="'required|email'"
                        :error-messages="errorMessages('email')"
                        :class="{ 'error--text': hasErrors('email') }"
                        class="primary--text"
                        label="E-mail"
                        data-vv-name="email"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.password"
                        :v-validate="[ parseInt(form.id) ? 'required' : '']"
                        :error-messages="errorMessages('password')"
                        :class="{ 'error--text': hasErrors('password') }"
                        ref="password"
                        type="password"
                        class="primary--text"
                        label="Parola"
                        data-vv-name="password"
                        counter="255"
                    />
                    <v-text-field
                        v-model="form.password_confirmation"
                        :v-validate="[ parseInt(form.id) ? 'required' : '', 'confirmed:password']"
                        :error-messages="errorMessages('password_confirmation')"
                        :class="{ 'error--text': hasErrors('password_confirmation') }"
                        class="primary--text"
                        type="password"
                        label="Confirmare parola"
                        data-vv-name="password_confirmation"
                        counter="255"
                    />
                    <v-checkbox
                        v-model="form.active"
                        :error-messages="errorMessages('active')"
                        :class="{ 'error--text': hasErrors('active') }"
                        class="primary--text"
                        label="Activ"
                        data-vv-name="active"
                        counter="255"
                    />

                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Alte informatii
                    </v-subheader>
                    <v-select
                        v-model="form.roles"
                        :items="roles"
                        item-text="display_name"
                        item-value="id"
                        :error-messages="errorMessages('roles')"
                        :class="{ 'error--text': hasErrors('roles') }"
                        class="primary--text"
                        label="Roluri"
                        data-vv-name="roles"
                        multiple
                    />

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    import swal from "sweetalert2";

    export default {
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            roles: [],
            image: null,
            imagePath: undefined,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                name: null,
                email: null,
                username: null,
                active: false,
                roles: [],
                data: {
                    family_name: undefined,
                    name: undefined,
                    gender: undefined,

                    id_serial: undefined,
                    id_no: undefined,
                    pin: undefined,

                    county_id: undefined,
                    city: undefined,
                    address: undefined,
                    address_no: undefined,
                    address_ap: undefined,
                    birthday: undefined,
                    function: undefined,
                    department: undefined,
                }
            }),
        }),
        computed: {
            genders() {
                let genders = this._.get(this.Static, 'genders', {})
                return Object.keys(genders).map((genderKey) => {
                    return {
                        name: genders[genderKey],
                        value: parseInt(genderKey)
                    }
                })
            },
            departments() {
                let departments = this._.get(this.Static, 'employeeDepartments', {})
                return Object.keys(departments).map((key) => {
                    return {
                        name: departments[key],
                        value: parseInt(key)
                    }
                })
            }
        },
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
            this.roles = await this.$db.Role
                .limit(50)
                .get()
                .then(({data}) => data)
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let data = await this.$db.Employee
                    .include('roles')
                    .append('workstations', 'profile_image')
                    .find(this.id)
                    .then(({data}) => {
                        data.roles = data.roles.map(role => role.id)
                        return data
                    })
                self.form = new Form(Object.assign(self.form, data))
                self.imagePath = data.profile_image
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                let model = new this.$db.Employee(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(async (response) => {
                        if(this.image) {
                            await this.uploadFile(model.mediaEndpoint(), [{
                                'name': 'image',
                                'file': this.image
                            }])
                        }
                        return response
                    })
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "employees-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            },
            changePreview() {
                if (this.image !== undefined) {
                    this.imagePath = URL.createObjectURL(this.image)
                } else {
                    this.imagePath = undefined
                }
            }
        }
    };
</script>
